import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { InterventiService } from '../../../services/interventi.service';
import { TieredMenu } from 'primeng/tieredmenu';
import { Menu } from 'primeng/menu';
import { ComunicaDeterminaComponent } from '../comunica-determina/comunica-determina.component';
import { ModificaRendicontazioneComponent } from '../modifica-rendicontazione/modifica-rendicontazione.component';
import { CaricaDocumentiRendicontazioneComponent } from '../carica-documenti-rendicontazione/carica-documenti-rendicontazione.component';
import { ConfermaEliminazioneFileComponent } from '../conferma-eliminazione-file/conferma-eliminazione-file.component';
import { ListaFileRendicontazioneComponent } from '../lista-file-rendicontazione/lista-file-rendicontazione.component';
import { Rendicontazione } from '../../../models/rendicontazione.model';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';
import { saveAs } from 'file-saver';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

@Component({
  selector: 'app-stato-rendicontazione',
  templateUrl: './stato-rendicontazione.component.html',
  styleUrls: ['./stato-rendicontazione.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    TableModule,
    TooltipModule,
    ToastModule,
    TieredMenuModule,
    ComunicaDeterminaComponent,
    ModificaRendicontazioneComponent,
    CaricaDocumentiRendicontazioneComponent,
    ConfermaEliminazioneFileComponent,
    ListaFileRendicontazioneComponent,
    LottieComponent,
  ],
  providers: [MessageService, NGXLogger],
})
export class StatoRendicontazioneComponent implements OnInit, AfterViewInit {
  @ViewChild('azioniMenuTiered') azioniMenuTiered!: Menu;
  @ViewChild(ComunicaDeterminaComponent)
  comunicaDeterminaComponent!: ComunicaDeterminaComponent;
  @ViewChild(ModificaRendicontazioneComponent)
  modificaRendicontazioneComponent!: ModificaRendicontazioneComponent;
  @ViewChild('caricaDocumentiComponent')
  caricaDocumentiComponent!: CaricaDocumentiRendicontazioneComponent;
  @Input() isEnteEsecutore: boolean = false;
  @Output() rendicontazioneEliminata = new EventEmitter<void>();
  @Output() interventiAggiornati = new EventEmitter<void>();
  visible: boolean = false;
  intervento: any;
  rendicontazioni: Rendicontazione[] = [];
  menuAzioniItems: any[] = [];
  selectedRendicontazione: Rendicontazione | null = null;
  isDownloading: boolean = false;
  showConfermaEliminazioneFile: boolean = false;
  showListaFile: boolean = false;
  showConfermaEliminazioneRendicontazione: boolean = false;

  options: AnimationOptions = {
    path: '/assets/animations/spinner-uploading.json',
    loop: true,
    autoplay: true,
  };

  // Cache per la verifica della presenza dei file
  private fileCheckCache: Map<
    number,
    { hasFiles: boolean; timestamp: number }
  > = new Map();
  private readonly CACHE_DURATION = 300000; // 5 minuti di cache
  // Stato di caricamento per la verifica dei file
  isCheckingFiles: boolean = false;

  constructor(
    private messageService: MessageService,
    private logger: NGXLogger,
    private interventiService: InterventiService,
    private firebaseStorageService: FirebaseStorageService,
  ) {}

  show(intervento: any) {
    this.intervento = intervento;
    this.visible = true;
    this.caricaStoricoRendicontazioni();
  }

  ngOnInit() {
    //this.caricaStoricoRendicontazioni();
  }

  ngAfterViewInit() {
    // Verifica che tutti i componenti ViewChild siano disponibili
  }

  caricaStoricoRendicontazioni() {
    this.interventiService
      .getStoricoRendicontazioni(this.intervento.id)
      .subscribe(
        (res: any) => {
          this.rendicontazioni = res;
          this.logger.info(JSON.stringify(this.rendicontazioni));
          // Verifica rapida della presenza di file per ogni rendicontazione
          this.verificaPresenzaFileRendicontazioni();
        },
        (err: any) => {
          this.logger.error(
            '[STORICO RENDICONTAZIONI] Errore nel caricamento dello storico',
            err,
          );
        },
      );
    // Per ora utilizziamo dati di esempio
    /* this.rendicontazioni = [
      {
        id: 1,
        data: new Date('2024-03-15'),
        tipo: 'ACCONTO',
        importo: 50000,
        note: 'Prima rendicontazione',
        stato: 'APPROVATA',
        documenti: ['fattura1.pdf', 'determina.pdf']
      },
      {
        id: 2,
        data: new Date('2024-04-01'),
        tipo: 'SALDO',
        importo: 75000,
        note: 'Rendicontazione finale',
        stato: 'IN ATTESA',
        documenti: ['fattura2.pdf']
      }
    ]; */
  }

  hide() {
    this.visible = false;
  }

  getTotaleRendicontato(): number {
    return this.rendicontazioni.reduce(
      (totale, rendicontazione) => totale + rendicontazione.importo,
      0,
    );
  }

  /**
   * Estrae il nome del file da un URL Firebase Storage
   * @param filePath URL completo del file su Firebase Storage
   * @returns Nome del file decodificato
   */
  private extractFileNameFromUrl(filePath: string): string {
    try {
      // Parsing dell'URL per estrarre il path
      const url = new URL(filePath);

      // Estrai il path dall'URL (es: /o/interventi%2F605%2Frendicontazioni%2F211%2FD2-2024-00419-00161.PDF_0.P7M)
      const pathSegments = url.pathname.split('/');

      // Trova l'ultimo segmento che contiene il nome del file
      const fileNameSegment = pathSegments[pathSegments.length - 1];

      // Decodifica l'URL encoding
      const decodedPath = decodeURIComponent(fileNameSegment);

      // Estrai solo il nome del file (ultima parte del path decodificato)
      const fileName = decodedPath.split('/').pop() || 'documento';

      this.logger.info('[STORICO RENDICONTAZIONI] Nome file estratto', {
        original: filePath,
        fileNameSegment,
        decodedPath,
        fileName,
      });

      return fileName;
    } catch (error) {
      this.logger.error('[STORICO RENDICONTAZIONI] Errore parsing URL', error);
      return 'documento_sconosciuto';
    }
  }

  scaricaDocumentiRendicontazione(rendicontazione: Rendicontazione) {
    this.isDownloading = true;
    const path = `interventi/${rendicontazione.intervento}/rendicontazioni/${rendicontazione.id}`;
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Download documenti rendicontazione',
      path,
    );

    this.firebaseStorageService.listFiles(path).subscribe(
      (files: string[]) => {
        this.logger.info(
          '[STORICO RENDICONTAZIONI] Documenti rendicontazione trovati',
          files,
        );
        if (files && files.length > 0) {
          let filesDownloaded = 0;
          files.forEach((filePath) => {
            this.firebaseStorageService.downloadFile(filePath).subscribe(
              (blob: Blob) => {
                this.logger.info('[STORICO RENDICONTAZIONI] DOC ', filePath);

                const decodedFileName = this.extractFileNameFromUrl(filePath);
                saveAs(blob, decodedFileName);
                filesDownloaded++;
                if (filesDownloaded === files.length) {
                  this.isDownloading = false;
                }
              },
              (error: any) => {
                this.logger.error(
                  '[STORICO RENDICONTAZIONI] Errore nel download del documento',
                  error,
                );
                this.messageService.add({
                  severity: 'error',
                  summary: 'Errore',
                  detail: `Errore nel download del documento`,
                });
                this.isDownloading = false;
              },
            );
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Nessun documento trovato per questa rendicontazione',
          });
          this.isDownloading = false;
        }
      },
      (error: any) => {
        this.logger.error(
          '[STORICO RENDICONTAZIONI] Errore nel recupero dei documenti rendicontazione',
          error,
        );
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel recupero dei documenti della rendicontazione',
        });
        this.isDownloading = false;
      },
    );
  }

  scaricaDocumentiDetermina(rendicontazione: Rendicontazione) {
    this.isDownloading = true;
    const path = `interventi/${rendicontazione.intervento}/determine-umvs/${rendicontazione.id}`;
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Download documenti determina',
      path,
    );

    this.firebaseStorageService.listFiles(path).subscribe(
      (files: string[]) => {
        this.logger.info(
          '[STORICO RENDICONTAZIONI] Documenti determina trovati',
          files,
        );
        if (files && files.length > 0) {
          let filesDownloaded = 0;
          files.forEach((filePath) => {
            this.firebaseStorageService.downloadFile(filePath).subscribe(
              (blob: Blob) => {
                this.logger.info(
                  '[STORICO RENDICONTAZIONI] DOC DETERMINA ',
                  filePath,
                );
                const decodedFileName = this.extractFileNameFromUrl(filePath);
                saveAs(blob, decodedFileName);
                filesDownloaded++;
                if (filesDownloaded === files.length) {
                  this.isDownloading = false;
                }
              },
              (error: any) => {
                this.logger.error(
                  '[STORICO RENDICONTAZIONI] Errore nel download del documento',
                  error,
                );
                this.messageService.add({
                  severity: 'error',
                  summary: 'Errore',
                  detail: `Errore nel download del documento`,
                });
                this.isDownloading = false;
              },
            );
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Nessun documento trovato per questa determina',
          });
          this.isDownloading = false;
        }
      },
      (error: any) => {
        this.logger.error(
          '[STORICO RENDICONTAZIONI] Errore nel recupero dei documenti determina',
          error,
        );
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel recupero dei documenti della determina',
        });
        this.isDownloading = false;
      },
    );
  }

  openCaricaAzioni(event: any, rendicontazione: Rendicontazione) {
    this.selectedRendicontazione = rendicontazione;
    this.loadAzioni(event, rendicontazione);
    if (this.azioniMenuTiered) {
      this.azioniMenuTiered.toggle(event);
    }
  }

  loadAzioni(event: any, rendicontazione: Rendicontazione) {
    this.menuAzioniItems = [];
    const hasDetermina = this.hasDeterminaComunicated(rendicontazione);

    // Azioni Modifica/Elimina disponibili SOLO se non è stata comunicata la determina
    if (!hasDetermina) {
      this.menuAzioniItems.push({
        label: 'Modifica',
        icon: PrimeIcons.PENCIL,
        style: { 'font-size': '12px' },
        command: () => this.modificaRendicontazione(rendicontazione),
      });
      this.menuAzioniItems.push({
        label: 'Elimina',
        icon: PrimeIcons.TRASH,
        style: { 'font-size': '12px', color: '#b91c1c' },
        command: () =>
          this.mostraConfermaEliminazioneRendicontazione(rendicontazione),
      });
    }
    if (!this.isEnteEsecutore) {
      this.menuAzioniItems.push({
        label: rendicontazione.numeroDetermina
          ? 'Modifica determina liquidazione'
          : 'Comunica determina liquidazione',
        icon: PrimeIcons.BOOK,
        style: { 'font-size': '10px' },
        command: () => this.comunicaDetermina(rendicontazione),
      });
    }
  }

  modificaRendicontazione(rendicontazione: Rendicontazione) {
    if (this.hasDeterminaComunicated(rendicontazione)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Azione non consentita',
        detail:
          'Non puoi modificare una rendicontazione dopo la comunicazione della determina.',
        life: 3500,
      });
      return;
    }
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Modifica rendicontazione',
      rendicontazione,
    );
    this.selectedRendicontazione = rendicontazione;
    this.modificaRendicontazioneComponent.show(
      rendicontazione,
      this.intervento,
    );
  }

  comunicaDetermina(rendicontazione: Rendicontazione) {
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Comunica determina',
      rendicontazione,
    );
    this.selectedRendicontazione = rendicontazione;
    this.comunicaDeterminaComponent.show(rendicontazione);
  }
  onComunicaDetermina(event: any) {
    this.logger.info('[STORICO RENDICONTAZIONI] Comunica determina', event);
    this.caricaStoricoRendicontazioni();
    this.interventiAggiornati.emit();
  }

  onRendicontazioneModificata(rendicontazione: Rendicontazione) {
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Rendicontazione modificata',
      rendicontazione,
    );
    this.caricaStoricoRendicontazioni();
  }

  caricaNuoviDocumenti(rendicontazione: Rendicontazione) {
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Carica nuovi documenti',
      rendicontazione,
    );
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Componente disponibile?',
      !!this.caricaDocumentiComponent,
    );
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Intervento disponibile?',
      !!this.intervento,
    );

    if (!this.caricaDocumentiComponent) {
      this.logger.error(
        '[STORICO RENDICONTAZIONI] Componente carica documenti non disponibile',
      );
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Componente non disponibile. Riprova.',
        life: 3000,
      });
      return;
    }

    if (!this.intervento) {
      this.logger.error('[STORICO RENDICONTAZIONI] Intervento non disponibile');
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Intervento non disponibile.',
        life: 3000,
      });
      return;
    }

    this.selectedRendicontazione = rendicontazione;
    this.logger.info('[STORICO RENDICONTAZIONI] Chiamata show su componente', {
      rendicontazione: rendicontazione.id,
      intervento: this.intervento.id,
    });
    this.caricaDocumentiComponent.show(rendicontazione, this.intervento);
  }

  onDocumentiCaricati() {
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Documenti caricati con successo',
    );
    // Invalida la cache per la rendicontazione corrente
    if (this.selectedRendicontazione) {
      this.invalidaCacheRendicontazione(this.selectedRendicontazione.id);
    }
    this.caricaStoricoRendicontazioni();
  }

  /**
   * Invalida la cache per una specifica rendicontazione
   * Da chiamare quando i documenti vengono modificati
   */
  private invalidaCacheRendicontazione(rendicontazioneId: number) {
    this.fileCheckCache.delete(rendicontazioneId);
    this.logger.info(
      `[STORICO RENDICONTAZIONI] Cache invalidata per rendicontazione ${rendicontazioneId}`,
    );
  }

  /**
   * Mostra la modale di conferma per l'eliminazione di tutti i file
   */
  mostraConfermaEliminazioneFile(rendicontazione: Rendicontazione) {
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Richiesta eliminazione tutti i file',
    );
    this.showConfermaEliminazioneFile = true;
    this.selectedRendicontazione = rendicontazione;
  }

  /**
   * Richiede conferma per eliminare una rendicontazione (record lato backend)
   * È richiamabile solo se NON è stata comunicata la determina
   */
  mostraConfermaEliminazioneRendicontazione(rendicontazione: Rendicontazione) {
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Richiesta eliminazione rendicontazione',
      rendicontazione,
    );

    if (this.hasDeterminaComunicated(rendicontazione)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Azione non consentita',
        detail:
          'Non puoi eliminare una rendicontazione dopo la comunicazione della determina.',
        life: 3500,
      });
      return;
    }

    if (!this.intervento || !this.intervento.id || !rendicontazione.id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail:
          "Intervento o rendicontazione non disponibile per l'eliminazione",
        life: 3000,
      });
      return;
    }

    this.selectedRendicontazione = rendicontazione;
    this.showConfermaEliminazioneRendicontazione = true;
  }

  /**
   * Conferma ed esegue l'eliminazione della rendicontazione selezionata
   */
  confermaEliminazioneRendicontazione() {
    if (
      !this.intervento ||
      !this.intervento.id ||
      !this.selectedRendicontazione?.id
    ) {
      this.showConfermaEliminazioneRendicontazione = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail:
          "Intervento o rendicontazione non disponibile per l'eliminazione",
        life: 3000,
      });
      return;
    }

    const interventoId = this.intervento.id;
    const rendicontazioneId = this.selectedRendicontazione.id;

    this.logger.info(
      '[STORICO RENDICONTAZIONI] Conferma eliminazione rendicontazione',
      {
        interventoId,
        rendicontazioneId,
      },
    );

    this.interventiService
      .eliminaRendicontazione(interventoId, rendicontazioneId)
      .subscribe({
        next: () => {
          this.showConfermaEliminazioneRendicontazione = false;
          // Rimuovi localmente la rendicontazione eliminata
          this.rendicontazioni = this.rendicontazioni.filter(
            (r) => r.id !== rendicontazioneId,
          );

          // Se non ci sono altre rendicontazioni, chiudi il dialog principale
          if (!this.rendicontazioni.length) {
            this.visible = false;
          }

          this.rendicontazioneEliminata.emit();
          this.messageService.add({
            severity: 'success',
            summary: 'Rendicontazione eliminata',
            detail: 'La rendicontazione è stata eliminata correttamente.',
            life: 3000,
          });

          // Ricarica l’elenco rendicontazioni se il dialog è ancora aperto
          if (this.visible) {
            this.caricaStoricoRendicontazioni();
          }
        },
        error: (error) => {
          this.showConfermaEliminazioneRendicontazione = false;
          this.logger.error(
            '[STORICO RENDICONTAZIONI] Errore eliminazione rendicontazione',
            error,
          );
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail:
              "Si è verificato un errore durante l'eliminazione della rendicontazione.",
            life: 4000,
          });
        },
      });
  }

  /**
   * Mostra la modale con l'elenco dei file della rendicontazione
   */
  mostraListaFile(rendicontazione: Rendicontazione) {
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Visualizzazione lista file',
      rendicontazione,
    );
    this.selectedRendicontazione = rendicontazione;
    this.showListaFile = true;
  }

  /**
   * Elimina tutti i file di rendicontazione dallo storage Firebase
   */
  eliminaFileRendicontazione() {
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Inizio eliminazione tutti i file della rendicontazione ',
      this.selectedRendicontazione,
    );

    if (
      !this.intervento ||
      !this.intervento.id ||
      !this.selectedRendicontazione
    ) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail:
          "Intervento o rendicontazione non disponibile per l'eliminazione dei file",
        life: 3000,
      });
      return;
    }

    this.isDownloading = true; // Riutilizzo il flag per mostrare il loading

    // Path per i documenti di rendicontazione
    const rendicontazionePath = `interventi/${this.selectedRendicontazione.intervento}/rendicontazioni/${this.selectedRendicontazione.id}`;

    // Path per i documenti delle determine UMVS
    const determinePath = `interventi/${this.selectedRendicontazione.intervento}/determine-umvs/${this.selectedRendicontazione.id}`;

    const pathsToDelete = [rendicontazionePath, determinePath];
    this.logger.info(
      '[STORICO RENDICONTAZIONI] Path da eliminare',
      pathsToDelete,
    );

    let deletedPaths = 0;
    let totalPaths = pathsToDelete.length;
    let hasErrors = false;

    if (totalPaths === 0) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Nessun file da eliminare',
        life: 3000,
      });
      this.isDownloading = false;
      return;
    }

    // Elimina i file per ogni path
    pathsToDelete.forEach((path) => {
      this.firebaseStorageService.listFiles(path).subscribe({
        next: (files: string[]) => {
          if (files && files.length > 0) {
            let deletedFiles = 0;
            files.forEach((filePath) => {
              // Estrai il path relativo dal full URL
              const relativePath = this.extractRelativePathFromUrl(filePath);

              this.firebaseStorageService.deleteFile(relativePath).subscribe({
                next: () => {
                  this.logger.info(
                    `[STORICO RENDICONTAZIONI] File eliminato: ${relativePath}`,
                  );
                  deletedFiles++;

                  if (deletedFiles === files.length) {
                    deletedPaths++;
                    this.checkEliminazioneCompleta(
                      deletedPaths,
                      totalPaths,
                      hasErrors,
                    );
                  }
                },
                error: (error) => {
                  this.logger.error(
                    `[STORICO RENDICONTAZIONI] Errore eliminazione file: ${relativePath}`,
                    error,
                  );
                  hasErrors = true;
                  deletedFiles++;

                  if (deletedFiles === files.length) {
                    deletedPaths++;
                    this.checkEliminazioneCompleta(
                      deletedPaths,
                      totalPaths,
                      hasErrors,
                    );
                  }
                },
              });
            });
          } else {
            // Nessun file in questo path, continua
            deletedPaths++;
            this.checkEliminazioneCompleta(deletedPaths, totalPaths, hasErrors);
          }
        },
        error: (error) => {
          this.logger.error(
            `[STORICO RENDICONTAZIONI] Errore nel listare i file per il path: ${path}`,
            error,
          );
          hasErrors = true;
          deletedPaths++;
          this.checkEliminazioneCompleta(deletedPaths, totalPaths, hasErrors);
        },
      });
    });
  }

  /**
   * Controlla se l'eliminazione di tutti i file è completata
   */
  private checkEliminazioneCompleta(
    deletedPaths: number,
    totalPaths: number,
    hasErrors: boolean,
  ) {
    if (deletedPaths >= totalPaths) {
      this.isDownloading = false;

      if (hasErrors) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail:
            'Eliminazione completata con alcuni errori. Controlla i log per i dettagli.',
          life: 5000,
        });
      } else {
        this.messageService.add({
          severity: 'success',
          summary: 'Successo',
          detail:
            'Tutti i file di rendicontazione sono stati eliminati con successo',
          life: 5000,
        });
      }

      // Invalida la cache per la rendicontazione corrente
      if (this.selectedRendicontazione) {
        this.invalidaCacheRendicontazione(this.selectedRendicontazione.id);
        // Aggiorna la proprietà hasFiles
        this.selectedRendicontazione.hasFiles = false;
      }

      this.logger.info(
        '[STORICO RENDICONTAZIONI] Eliminazione file completata',
        {
          deletedPaths,
          totalPaths,
          hasErrors,
        },
      );
    }
  }

  /**
   * Estrae il path relativo da un URL completo di Firebase Storage
   */
  private extractRelativePathFromUrl(fullUrl: string): string {
    try {
      const url = new URL(fullUrl);
      const pathSegments = url.pathname.split('/');

      // Trova l'indice del segmento 'o' che precede il path del file
      const oIndex = pathSegments.findIndex((segment) => segment === 'o');
      if (oIndex !== -1 && oIndex + 1 < pathSegments.length) {
        // Prendi tutto dopo '/o/' e decodifica
        const encodedPath = pathSegments.slice(oIndex + 1).join('/');
        return decodeURIComponent(encodedPath);
      }

      // Fallback: usa l'URL originale
      this.logger.warn(
        '[STORICO RENDICONTAZIONI] Impossibile estrarre path relativo, uso URL completo',
        fullUrl,
      );
      return fullUrl;
    } catch (error) {
      this.logger.error(
        "[STORICO RENDICONTAZIONI] Errore nell'estrazione del path relativo",
        error,
      );
      return fullUrl;
    }
  }

  /**
   * Verifica rapidamente la presenza di file per tutte le rendicontazioni
   * Utilizza un sistema di cache per evitare chiamate multiple
   */
  private verificaPresenzaFileRendicontazioni() {
    this.isCheckingFiles = true;
    let completedChecks = 0;
    const totalChecks = this.rendicontazioni.length;

    if (totalChecks === 0) {
      this.isCheckingFiles = false;
      return;
    }

    this.rendicontazioni.forEach((rendicontazione) => {
      this.verificaPresenzaFileRendicontazione(rendicontazione, () => {
        completedChecks++;
        if (completedChecks >= totalChecks) {
          this.isCheckingFiles = false;
        }
      });
    });
  }

  /**
   * Verifica rapidamente la presenza di file per una singola rendicontazione
   * Utilizza la cache per evitare chiamate multiple
   */
  private verificaPresenzaFileRendicontazione(
    rendicontazione: Rendicontazione,
    callback?: () => void,
  ) {
    const cacheKey = rendicontazione.id;
    const now = Date.now();
    const cached = this.fileCheckCache.get(cacheKey);

    // Se abbiamo un risultato in cache valido, usalo
    if (cached && now - cached.timestamp < this.CACHE_DURATION) {
      rendicontazione.hasFiles = cached.hasFiles;
      if (callback) {
        callback();
      }
      return;
    }

    // Altrimenti, esegui la verifica
    this.verificaPresenzaFileStorage(rendicontazione, () => {
      if (callback) {
        callback();
      }
    });
  }

  /**
   * Verifica la presenza di file nello storage Firebase per una rendicontazione
   */
  private verificaPresenzaFileStorage(
    rendicontazione: Rendicontazione,
    callback?: () => void,
  ) {
    const path = `interventi/${rendicontazione.intervento}/rendicontazioni/${rendicontazione.id}`;

    this.firebaseStorageService.listFiles(path).subscribe({
      next: (files: string[]) => {
        const hasFiles = files && files.length > 0;

        // Aggiorna la proprietà della rendicontazione
        rendicontazione.hasFiles = hasFiles;

        // Salva in cache
        this.fileCheckCache.set(rendicontazione.id, {
          hasFiles,
          timestamp: Date.now(),
        });

        this.logger.info(
          `[STORICO RENDICONTAZIONI] Rendicontazione ${rendicontazione.id} - File presenti: ${hasFiles}`,
        );
        if (callback) {
          callback();
        }
      },
      error: (error) => {
        this.logger.error(
          `[STORICO RENDICONTAZIONI] Errore verifica file rendicontazione ${rendicontazione.id}`,
          error,
        );
        // In caso di errore, assumiamo che non ci siano file
        rendicontazione.hasFiles = false;

        // Salva in cache anche l'errore per evitare chiamate multiple
        this.fileCheckCache.set(rendicontazione.id, {
          hasFiles: false,
          timestamp: Date.now(),
        });
        if (callback) {
          callback();
        }
      },
    });
  }

  /**
   * Verifica rapidamente se una rendicontazione ha file per le determine
   */
  hasDeterminaFiles(rendicontazione: Rendicontazione): boolean {
    // Se non c'è numero determina, non ci possono essere file
    if (!rendicontazione.numeroDetermina) {
      return false;
    }

    // Per ora restituiamo true se c'è un numero determina
    // In futuro si potrebbe implementare una verifica simile per i file delle determine
    return true;
  }

  private hasDeterminaComunicated(rendicontazione: Rendicontazione): boolean {
    return !!rendicontazione?.numeroDetermina?.toString().trim();
  }
}
